module.exports = __webpack_public_path__ + "static/media/ICON-SOBRE2.903d9c66.svg";